export const HISTORY_DATA =
  "https://data.covid19india.org/v4/min/timeseries.min.json";
export const LATEST_DATA = "https://data.covid19india.org/v4/min/data.min.json";
export const COLORS = {
  confirmed: "237,66,66",
  active: "33,127,246",
  recovered: "76,167,70",
  deceased: "108,117,124",
  tested: "104,23,51",
  vaccinated: "240,133,72",
};
export const STATE_CODES = {
  TT: "Total",
  AP: "Andhra Pradesh",
  AN: "Andaman and Nicobar Islands",
  AR: "Arunachal Pradesh",
  AS: "Assam",
  BR: "Bihar",
  CH: "Chandigarh",
  CT: "Chhattisgarh",
  DN: "Dadra and Nagar Havel and Daman and Diu",
  DL: "Delhi",
  GA: "Goa",
  GJ: "Gujarat",
  HR: "Haryana",
  HP: "Himachal Pradesh",
  JK: "Jammu and Kashmir",
  JH: "Jharkhand",
  KA: "Karnataka",
  KL: "Kerala",
  LA: "Ladakh",
  LD: "Lakshadweep",
  MP: "Madhya Pradesh",
  MH: "Maharashtra",
  MN: "Manipur",
  ML: "Meghalaya",
  MZ: "Mizoram",
  NL: "Nagaland",
  OR: "Odisha",
  PY: "Puducherry",
  PB: "Punjab",
  RJ: "Rajasthan",
  SK: "Sikkim",
  TN: "Tamil Nadu",
  TG: "Telangana",
  TR: "Tripura",
  UP: "Uttar Pradesh",
  UT: "Uttarakhand",
  WB: "West Bengal",
  UN: "Unknown",
};
